export const CHANGE_TYPE = Object.freeze({
  EDIT: 'edit',
  DELETE: 'delete',
  NEW: 'new',
  UPGRADE: 'upgrade'
}) 